import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBottle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bottle, wine, campaign"><path d="M14 1.75V7.25L17.25 10.25V22.25H6.75V10.25L10 7.25V1.75H14ZM14 1.75H14.625" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10 1.75H9.375" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBottle;
